import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  btnsContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionBtn: {
    fontSize: '14px',
    width: 38,
    height: 38,
    '&:not(:last-child)': {
      marginRight: 8
    }
  },
  approveBtn: {
    marginLeft: 'auto',
    flexGrow: 1
  }
})

export default useStyles
